import { Message } from 'view-design'
import { appRouter } from '../router/index'
import Cookies from 'js-cookie'
import moment from 'moment'
moment.suppressDeprecationWarnings = true;
const _ = require('lodash')

export const TOKEN_KEY = 'TOKEN'

export const setToken = (token) => {
  Cookies.set(TOKEN_KEY, token, { expires: 1 })
}

export const getToken = () => {
  const token = Cookies.get(TOKEN_KEY)
  if (token) return token
  else return false
}

export const setItem = (key, value) => {
  document.cookie = key + '=' + value;
}

export const getItem = (key) => {
  return Cookies.get(key)
}

export const rmItem = function (key) {
  Cookies.remove(key)
}

let util = {}
util.title = function (title) {
  window.document.title = title
}

util.mode = function (obj) {
  let oc = {}
  Object.keys(obj).forEach(function (key) {
    if (typeof obj[key] === 'string') {
      if (obj[key] === '1') {
        oc[key] = '是'
      } else {
        oc[key] = '否'
      }
    } else if (typeof obj[key] === 'object') {
      oc[key] = obj[key]
    } else if (typeof obj[key] !== 'undefined') {
      oc[key] = obj[key].toString()
    } else {
      oc[key] = ''
    }
  })
  return oc
}

util.getQueryVariable = function (variable) {
  if (window.location.hash.indexOf('?') === -1) {
    return '/home';
  }
  var query = window.location.hash.split('?')
  query.splice(0, 1)
  var vars = query.join('?').split('&');
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split('=');
    if (pair[0] === variable) {
      return pair[1];
    }
  }
  return '/home';
}

util.error = function (vm, error) {
  let text = error
  if (error.response !== undefined) {
    if (error.response.status === 401) {
      let redirect = vm.$util.getQueryVariable('redirect')
      vm.$Modal.confirm({
        title: '登录信息过期，请重新登录!',
        cancelText: '取消',
        okText: '重新登录',
        closable: false,
        onOk: () => {
          vm.$util.rmItem('loginuser');
          vm.$util.rmItem('jwt');
          vm.$util.rmItem('auth');
          vm.$util.rmItem('display');
          vm.$util.rmItem('avatar');
          vm.$util.rmItem('TOKEN');
          vm.$util.rmItem('token');
          localStorage.clear()
          if (location.hash.indexOf('/login') === -1) {
            // 跳转
            window.location.href = '/#/login?redirect=' + redirect
            location.reload()
          } else {
            // 刷新
            location.reload()
          }
        }
      })
      return false
    } else if (error.response.status === 403) {
      text = '对不起，您没有该接口访问权限，请联系管理员'
    } else {
        text = error.response.data.msg
    }
  }
  if (text !== '登录信息失效！请重新登录!') {
    Message.error({
      background: true,
      content: text,
      duration: 3
    })
  }
}

util.auth_notice = function (error) {
  let text = error
  if (error.response !== undefined) {
    if (error.response.status === 400) {
      text = '账号密码错误,请重新输入!'
    }
  }
  Message.error({
    background: true,
    content: text
  })
}

util.notice = function (vl, duration) {
  if (duration !== undefined) {
    Message.success({
      background: true,
      content: vl,
      duration: duration
    })
  } else {
    Message.success({
      background: true,
      content: vl
    })
  }
}

util.info = function (vl, duration) {
  if (duration !== undefined) {
    Message.info({
      background: true,
      content: vl,
      duration: duration
    })
  } else {
    Message.info({
      background: true,
      content: vl
    })
  }
}

util.warning = function (vl, duration) {
  if (duration !== undefined) {
    Message.warning({
      content: vl,
      duration: duration
    })
  } else {
    Message.warning({
      content: vl
    })
  }
}

util.timeconver = function (vl) {
 return moment(new Date(vl)).format('YYYY-MM-DD HH:mm:ss')
}

util.timestamp = function (vl) {
  return moment.unix(vl).format('YYYY-MM-DD HH:mm:ss')
}

util.timestamptiwj = function (vl) {
  return moment.unix(vl).format('YYYY-MM-DD HH:mm:59')
}

util.nanotimestamp = function (vl) {
  return moment.unix(vl / 1000).format('YYYY-MM-DD HH:mm:ss.SSS')
}

util.unixtime = function (vl) {
  return moment(new Date(vl)).unix()
}

util.unixtimetonow = function (vl) {
  return moment(new Date(vl)).unix() - moment(new Date()).unix()
}

util.highlight = 'alter|and|as|asc|between|count|create|delete|desc|distinct|drop|from|having|in|insert|into|is|join|like|not|on|or|order|select|set|table|union|update|values|where|accessible|action|add|after|algorithm|all|analyze|asensitive|at|authors|auto_increment|autocommit|avg|avg_row_length|before|binary|binlog|both|btree|cache|call|cascade|cascaded|case|catalog_name|chain|change|changed|character|check|checkpoint|checksum|class_origin|client_statistics|close|coalesce|code|collate|collation|collations|column|columns|comment|commit|committed|completion|concurrent|condition|connection|consistent|constraint|contains|continue|contributors|convert|cross|current_date|current_time|current_timestamp|current_user|cursor|data|database|databases|day_hour|day_microsecond|day_minute|day_second|deallocate|dec|declare|default|delay_key_write|delayed|delimiter|des_key_file|describe|deterministic|dev_pop|dev_samp|deviance|directory|disable|discard|distinctrow|div|dual|dumpfile|each|elseif|enable|enclosed|end|ends|engine|engines|enum|errors|escape|escaped|even|event|events|every|execute|exists|exit|explain|extended|fast|fetch|field|fields|first|flush|for|force|foreign|found_rows|full|fulltext|function|general|global|grant|grants|group|groupby_concat|handler|hash|help|high_priority|hosts|hour_microsecond|hour_minute|hour_second|if|ignore|ignore_server_ids|import|index|index_statistics|infile|inner|innodb|inout|insensitive|insert_method|install|interval|invoker|isolation|iterate|key|keys|kill|language|last|leading|leave|left|level|limit|linear|lines|list|load|local|localtime|localtimestamp|lock|logs|low_priority|master|master_heartbeat_period|master_ssl_verify_server_cert|masters|match|max|max_rows|maxvalue|message_text|middleint|migrate|min|min_rows|minute_microsecond|minute_second|mod|mode|modifies|modify|mutex|mysql_errno|natural|next|no|no_write_to_binlog|offline|offset|one|online|open|optimize|option|optionally|out|outer|outfile|pack_keys|parser|partition|partitions|password|phase|plugin|plugins|prepare|preserve|prev|primary|privileges|procedure|processlist|profile|profiles|purge|query|quick|range|read|read_write|reads|real|rebuild|recover|references|regexp|relaylog|release|remove|rename|reorganize|repair|repeatable|replace|acequire|resignal|restrict|resume|return|returns|revoke|right|rlike|rollback|rollup|row|row_format|rtree|savepoint|schedule|schema|schema_name|schemas|second_microsecond|security|sensitive|separator|serializable|server|session|share|show|signal|slave|slow|smallint|snapshot|soname|spatial|specific|sql|sql_big_result|sql_buffer_result|sql_cache|sql_calc_found_rows|sql_no_cache|sql_small_result|sqlexception|sqlstate|sqlwarning|ssl|start|starting|starts|status|std|stddev|stddev_pop|stddev_samp|storage|straight_join|subclass_origin|sum|suspend|table_name|table_statistics|tables|tablespace|temporary|terminated|to|trailing|transaction|trigger|triggers|truncate|uncommitted|undo|uninstall|unique|unlock|upgrade|usage|use|use_frm|user|user_resources|user_statistics|using|utc_date|utc_time|utc_timestamp|value|variables|varying|view|views|warnings|when|while|with|work|write|xa|xor|year_month|zerofill|begin|do|then|else|loop|repeat|by|bool|boolean|bit|blob|decimal|double|enum|float|long|longblob|longtext|medium|mediumblob|mediumint|mediumtext|time|timestamp|tinyblob|tinyint|tinytext|text|bigint|int|int1|int2|int3|int4|int8|integer|float|float4|float8|double|char|varbinary|varchar|varcharacter|precision|date|datetime|year|unsigned|signed|numeric|ucase|lcase|mid|len|round|rank|now|format|coalesce|ifnull|isnull|nvl'

util.base = location.protocol + '//' + document.domain

util.url = util.base + '/api/v1'

util.auth = util.base + '/login/ldap'

util.logout = util.base + '/logout'

util.oneOf = function (ele, targetArr) {
  if (targetArr.indexOf(ele) >= 0) {
    return true
  } else {
    return false
  }
}

util.showThisRoute = function (itAccess, currentAccess) {
  if (typeof itAccess === 'object' && itAccess.isArray()) {
    return util.oneOf(currentAccess, itAccess)
  } else {
    return itAccess === currentAccess
  }
}

util.openPage = function (vm, name) {
  vm.$router.push({name: name})
  vm.$store.commit('Breadcrumbset', name)
  vm.$store.state.currentPageName = name
  util.taglist(vm, name)
}

util.taglist = function (vm, name) {
  vm.$store.state.pageOpenedList.forEach((vl, index) => {
    if (vl.name === name && name !== 'home_index') {
      vm.$store.state.pageOpenedList.splice(index, 1)
    }
  })
  appRouter.forEach((val) => {
    for (let i of val.children) {
      if (i.name === name && name !== 'home_index') {
        vm.$store.state.pageOpenedList.push({'title': i.title, 'name': i.name})
      }
    }
  })
  localStorage.setItem('pageOpenedList', JSON.stringify(vm.$store.state.pageOpenedList))
}

util.clearObj = function (obj) {
  for (let i in obj) {
    if (typeof obj[i] === 'object') {
      obj[i] = []
    } else if (typeof obj[i] === 'string') {
      obj[i] = ''
    } else {
      obj[i] = false
    }
  }
  return obj
}

util.sameMerge = function (obj, merge, el) {
  for (let i of Object.keys(el)) {
    obj[i] = merge[i]
  }
  return obj
}

util.filternode = function (node, key) {
  let result = null
  if (node.title.toLowerCase().indexOf(key.toLowerCase()) !== -1) {
    result = node
  } else if (node.children) {
    let childs = []
    for (let child of node.children) {
      let childnode = util.filternode(child, key)
      childnode && childs.push(childnode)
    }
    if (childs.length !== 0) {
      if (!result) {
        result = node
      }
      result.children = childs
      result.expand = true
    }
  }
  return result
}

util._ = _

util.setItem = function (key, value) {
  // Cookies.set(key, value)
  document.cookie = key + '=' + value;
}

util.getItem = function (key) {
  return Cookies.get(key)
}

util.rmItem = function (key) {
  Cookies.remove(key)
}

util.isMobile = function () {
  return navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
          );
}

export default util



// WEBPACK FOOTER //
// ./src/libs/util.js